import { render, staticRenderFns } from "./consort-place-marketing-suite.vue?vue&type=template&id=515bc74b&"
import script from "./consort-place-marketing-suite.vue?vue&type=script&lang=js&"
export * from "./consort-place-marketing-suite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports